import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Avatar, Col, Menu, Row, Typography, Image } from "antd";
import { useSelector } from "react-redux";
import PersonalDetails from "./Components/PersonalDetails";
import ChangePassword from "./Components/ChangePassword";
import BankDetails from "./Components/BankDetails";
import EscrowDetails from "./Components/EscrowDetails";
import KYCDetails from "./Components/KYCDetails";
import CompanyDetails from "./Components/CompanyDetails";
import ArrowRightBlack from "../../assets/icons/arrow-right-black.svg";
import ArrowRightBlue from "../../assets/icons/arrow-right-blue.svg";
import { TITLE_TXT } from "../../constants/constants";
import { isVenturesCategory } from "../../helpers/dealCategoryProducts";
import "./Profile.scss";

const { Title, Text } = Typography;

const Profile = () => {
  const location = useLocation();
  const { value } = location.state || {};
  const { user } = useSelector((state) => state.auth);
  const { activeCategory } = useSelector((state) => state.dealCategory);

  const dealCategoryId =
    activeCategory?.dealCategoryId || user?.dealCategories?.[0]?.dealCategoryId;
  const isJV = isVenturesCategory(dealCategoryId);

  const [activeComponent, setActiveComponent] = useState(
    value === "escrow" && isJV ? "personal" : value || "personal"
  );

  useEffect(() => {
    if (value) {
      setActiveComponent(value === "escrow" && isJV ? "personal" : value);
    }
  }, [value, isJV]);

  useEffect(() => {
    if (isJV && activeComponent === "escrow") {
      setActiveComponent("personal");
    }
  }, [isJV, activeComponent]);

  const handleMenuClick = (key) => setActiveComponent(key);

  const renderComponent = () => {
    const components = {
      personal: <PersonalDetails />,
      company: <CompanyDetails />,
      password: <ChangePassword />,
      bank: <BankDetails />,
      ...(!isJV && { escrow: <EscrowDetails /> }),
      kyc: <KYCDetails />
    };
    return components[activeComponent] || <PersonalDetails />;
  };

  const menuItems = [
    { key: "personal", label: TITLE_TXT.PER_DETS },
    { key: "company", label: TITLE_TXT.COMP_DETS },
    { key: "bank", label: TITLE_TXT.BANK_DETS },
    !isJV && { key: "escrow", label: TITLE_TXT.ECW_DETS },
    { key: "kyc", label: TITLE_TXT.KYC_DETS },
    { key: "password", label: TITLE_TXT.CHNG_PWD_TITLE },
  ].filter(Boolean);

  return (
    <Row gutter={[24, 16]} className="profile-container">
      <Col xs={24} lg={6}>
        <div className="profile-menu-container">
          <Avatar
            size={100}
            style={{
              backgroundColor: "#2243B6",
              color: "#ffffff",
              fontSize: 42,
              marginTop: 30
            }}
          >
            {user?.EnquiryMgmtView?.busName?.charAt(0).toUpperCase() || user?.userName?.charAt(0).toUpperCase() || "U"}
          </Avatar>
          <Title level={4}>{user?.EnquiryMgmtView?.busName || user?.userName}</Title>
          <Menu className="menuBlock" mode="inline" selectedKeys={[activeComponent]}>
            {menuItems.map(({ key, label }) => (
              <Menu.Item key={key} onClick={() => handleMenuClick(key)}>
                <Text>{label}</Text>
                <Image
                  src={activeComponent === key ? ArrowRightBlue : ArrowRightBlack}
                  preview={false}
                  alt="ArrowRight"
                />
              </Menu.Item>
            ))}
          </Menu>
        </div>
      </Col>
      <Col xs={24} lg={18}>
        {renderComponent()}
      </Col>
    </Row>
  );
};

export default Profile;
